// Kept in its own tiny module so the Footer (every page) does not pull the whole device catalog into the first bundle.
export const PERMANENT_DISCLAIMER =
  "Fire Alarm Blueprint Trainer provides educational guidance only. It does not replace professional engineering, licensed electrical work, approved fire alarm design, manufacturer installation instructions, applicable codes, or AHJ review.";
